export default __webpack_public_path__ + "static/media/management_panel_icon.0bd998eb.png";